import React, { createContext, useContext } from 'react';
import { fetchAllOnce } from '../hooks';

const AllInOneContext = createContext();

export const AllInOneProvider = ({ children }) => {
  const {
    maxModifiedAt,
    setMaxModifiedAt,
    lists,
    setLists,
    allTasks,
    setAllTasks,
    loadPage,
    progress, setProgress
  } = fetchAllOnce();
  

  return (
    <AllInOneContext.Provider
      value={{
        maxModifiedAt,
        setMaxModifiedAt,
        lists,
        setLists,
        allTasks,
        setAllTasks,
        loadPage,
        progress, setProgress
      }}
    >
      {children}
    </AllInOneContext.Provider>
  );
};

export const useAllInOneContext = () => useContext(AllInOneContext);
